import React from "react";
import "./ProgressPage.scss";
import withStyles from "@material-ui/core/styles/withStyles";
import { LinearProgress } from "@material-ui/core";

const LinearProgressThick = withStyles((theme) => ({
  root: {
    height: 7,
    borderRadius: 10,
  },
}))(LinearProgress);

const ProgressBar = (props: any) => {
  const { progressPercentage } = props;
  return (
      <LinearProgressThick variant = "determinate" value = { progressPercentage } />
    
  );
};

export default ProgressBar;
